import { render, staticRenderFns } from "./location-details.vue?vue&type=template&id=6b43bb96"
import script from "./location-details.vue?vue&type=script&lang=js"
export * from "./location-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports